import React from 'react';
import classNames from 'classnames';
import IgniteSlider from '@ignitesales/react-slider';
import { QuestionTypeViewPropTypes } from '@ignitesales/neuro-application/src/shapes';
import QuestionText from '@ignitesales/neuro-application/src/components/questions/QuestionText.jsx';

const SliderNumber = (props) => {
  const {
    valueChanged,
    question,
    value: { value = 0 } = {}
  } = props;

  const {
    appkey,
    attributes
  } = question;

  const cssBEM = 'slider';
  const format = attributes?.format || 'number';
  const selected = (value && value.length > 0) ? value[0] : value;

  const extended = false;
  const classes = {};
  classes[`${ cssBEM }--continuous`] = true;
  classes[`${ cssBEM }`] = true;
  classes[`${ cssBEM }--non-extended`] = !extended;
  classes[`${ cssBEM }--extended`] = extended;

  const getAnswerOptions = () => {
    const options = [];
    const min = attributes?.min || 0;
    const max = attributes?.max || 100;
    const step = attributes?.step || 1;
    for(let x = min; x <= max; x += step){
      options.push({
        label: x,
        value: x
      })
    }
    return options;
  };

  const prefix = format === 'currency' ? '$' : '';
  const suffix = format === 'percent' ? '%' : '';
  //TODO: update root slider so that it returns the value "beforeChange" value so we can use it in the UI before we actually call the server

  return (
    <div className="question question--slider question--slider-continuous" id={ appkey }>
      <QuestionText question={ question }/>
      <div className={`${cssBEM}__value`}>
        <span>{ prefix }{ value }{ suffix }</span>
      </div>
      <IgniteSlider
        name={ appkey }
        onChange={ valueChanged }
        selected={ selected }
        className={ classNames(classes) }
        answerOptions={ getAnswerOptions() }
        extended={ extended }
        continuousDrag={true}
      />
    </div>
  );
};

SliderNumber.propTypes = QuestionTypeViewPropTypes;

export default SliderNumber;
